module.exports = {
  methodType: "POST",
  redirect: "follow",
  jobApplyUrl: "https://emailsvc-ext.syrasoft.com/v1/jobapply",
  senderMailID: "hireme@codeparva.com",
  bcc: "hireme@codeparva.com",
  receiverMailID:
    "a.t.205483734.u-55348032.4741842d-d28b-47e6-baf0-d7bbfa2fa521@tasks.clickup.com",
};
